module.exports = __webpack_public_path__ + "assets/img/windows-big.79b6c2d6.svg";